import React from "react"
import Layout from "../components/layout/layout"
import SEO from "../components/seo/seo"
import styled from "styled-components";

import Home from "../components/sections/home"
import Feedback from "../components/sections/feedback"
import Sidemenu from "../components/layout/sidebar"
import Faqsesction from "../components/sections/faq";
import Proposal from "../components/sections/proposal";
import BecomeATraderForm from "../components/sections/trader-form";
import Future from "../components/sections/future";
import About from "../components/sections/about";
import FeedbackFirst from "../components/sections/feedback-first";

const Content = styled.div`
  width: 70%;
  float: right;
  @media screen and (max-width: ${(props) =>
      props.theme.breakpoints.tablet}) {
    width: 100%;
  }
`

const IndexPage = () => {
  return (
    <Layout headerClass="home">
      <SEO
        title="Shepherd's Bush Market"
        description="Public consultation on future development for Shepherd’s Bush Market. Comment on the neighbourhood and local area via our collaborative map"
      />
      <Home />
        {/* <Future />
        <FeedbackFirst />
        <Proposal />
        <Feedback />
        <About />
        <Feedback /> */}
    </Layout>
  );
}

export default IndexPage
